import { createTheme } from '@mui/material'

// MUI base theme — carries the app's breakpoint scale used by the
// interactive MUI islands (MyAutocomplete, SearchInput) for their
// `theme.breakpoints.*` media queries. Kept in its own module (rather
// than styles/constants.js) so that importing raw color tokens does NOT
// eagerly run createTheme() — which would crash React Server Components
// ("Attempted to call createTheme() from the server"). Only client
// components should import this module.
export const MUI_THEME = createTheme({
  breakpoints: {
    values: {
      xxs: 0, // small phone
      xs: 480, // phone
      sm: 767, // tablets
      md: 991, // small laptop
      lg: 1440, // desktop
      xl: 1920 // large screens
    }
  }
})
